import { z } from "zod";
import { EMP, NAME, PROJECT_CODE, ROLE, TEAM } from "./consts";

export const schema = z.object({
  [NAME]: z.string().min(1, "This field is required"),
  [PROJECT_CODE]: z.string().min(1, "This field is required"),
  [TEAM]: z
    .object({
      [ROLE]: z.string().min(1, "This field is required"),
      [EMP]: z.string().min(1, "This field is required"),
    })
    .array()
    .min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
